var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
export default function DqMessage() {
    return (_jsx(_Fragment, { children: _jsx("div", { children: _jsx("div", __assign({ className: "px-7 py-3 bg-gray-500 text-white font-medium text-sm leading-snug uppercase rounded shadow-md" }, { children: "Thank you for providing us with your information. Based on your answers, we have come to the unfortunate conclusion that we will not be able to represent you. However, another attorney may have different criteria for accepting a claim and be willing to represent you. We encourage you to seek legal advice from another attorney if you desire a second opinion as to whether you should pursue a claim. We regret that we are unable to proceed with your potential case." }), void 0) }, void 0) }, void 0));
}
